import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useGetCustomerQuery } from "../../api/customerApi";
import { useGetProductQuery } from "../../api/productDetailSlice";
import { ChannelLanguagePair, ProductId } from "../product";
import { RootState } from "../../utils/store";
import { ProofreadRequestModal } from "./ProofreadRequestModal";
import {
  sendProductToProofreading,
  SendToProofreadingRequest,
  SendToProofreadingResponse,
} from "./proofreadActions";

type Props = {
  dialogRef: React.RefObject<HTMLDialogElement>;
  productId: ProductId;
};

export const ProductProofreadRequestModal: React.FC<Props> = ({
  dialogRef,
  productId,
}) => {
  const token = useSelector((state: RootState) => state.auth.token);
  const { data: customer } = useGetCustomerQuery();
  const { data: product } = useGetProductQuery(productId);

  const availablePairs = useMemo<ChannelLanguagePair[]>(() => {
    if (!product) return [];
    if (product.channel_language_pairs.length > 0) {
      return product.channel_language_pairs;
    }
    if (!customer) return [];
    return customer.channel_language_pairs
      .filter((p) => p.default)
      .map((p) => new ChannelLanguagePair(p.language_code, p.channel_id));
  }, [product, customer]);

  const submit = (
    payload: SendToProofreadingRequest
  ): Promise<SendToProofreadingResponse> =>
    sendProductToProofreading(token, productId, payload);

  return (
    <ProofreadRequestModal
      dialogRef={dialogRef}
      availablePairs={availablePairs}
      submit={submit}
    />
  );
};
